import { GridView } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { getSingleUsers, reset } from "../../Redux/UserSlice/UserSlice";

function Solutions() {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>
                {/* <ButtonTable>New</ButtonTable> */}
            </HeaderTable>

            <Outlet />
        </>
    );
}

export default Solutions;
